module.exports = __webpack_public_path__ + "static/media/oopsTBN.dfcbcd7a.png";